module.exports = __webpack_public_path__ + "img/Boss-5.fa34dda7.gif";